import { React, useState, useEffect } from "react";
import { TableBody, TableCell, TableHead, TableSortLabel } from "@mui/material";
import {
	StyledTable,
	TableWrapper,
	TableButton,
	StyledTableRow,
	StyledCheckbox,
	StyledTablePagination,
	TableToolbar,
} from "../../../components/DataTable/DataTable.styles";
import { Link } from "react-router-dom";
import { getFormattedDate } from "../../../utils/DateUtils";
import Tooltip from "@mui/material/Tooltip";
import { Select, MenuItem } from "@mui/material";
import DeleteIcon from "../../../assets/icons/deleteIcon.svg";
import ConfirmModal from "../../../components/ConfirmModal";
// import Parse from "../../../api/ApiConfig";
import { toast } from "react-toastify";
import { Backdrop, CircularProgress } from "@mui/material";
import { deleteMutltipleAccounts } from "../utils";
import { getNairaFormat } from "../../../utils/Utils";
// import { getApprenticeName } from "../utils";

/* eslint-disable react/prop-types */
function AccountTable({
	TableData,
	headCells,
	dateFilter,
	handleDateFilterChange,
	accountsData,
}) {
	const [confirmModal, setConfirmModal] = useState(false);
	// eslint-disable-next-line no-unused-vars
	const [loading, setLoading] = useState(false);
	const [order, setOrder] = useState("asc");
	const [orderBy, setOrderBy] = useState("");
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [selected, setSelected] = useState([]);

	useEffect(() => {
		setSelected([]);
		setPage(0);
		setOrder("asc");
		setOrderBy("");
	}, [TableData]);

	const deleteMultipleAccounts = async () => {
		// setLoading(true)
		if (selected.length > 0) {
			setConfirmModal(false);
			const selelctedIds = selected.map((user) => {
				return user.objectId;
			});
			let data = await deleteMutltipleAccounts(selelctedIds);
			try {
				if (data.result) {
					toast.success("account deleted successfully");
					accountsData();
				} else {
					toast.error("unable to delete account, please try again later");
				}
			} catch (error) {
				toast.error("unable to delete account, please try again later");
			}
		} else {
			toast.error("user(s) not found");
			return;
		}
	};

	const getVisibleRows = () => {
		function descendingComparator(a, b, orderBy) {
			if (b[orderBy] < a[orderBy]) {
				return -1;
			}
			if (b[orderBy] > a[orderBy]) {
				return 1;
			}
			return 0;
		}

		function getComparator(order, orderBy) {
			return order === "desc"
				? (a, b) => descendingComparator(a, b, orderBy)
				: (a, b) => -descendingComparator(a, b, orderBy);
		}

		// Check if TableData is not an array || TableData is empty
		if (Array.isArray(TableData)) {
			return TableData.slice().sort(getComparator(order, orderBy));
		} else return [];
	};

	const visibleRows = getVisibleRows().slice(
		page * rowsPerPage,
		page * rowsPerPage + rowsPerPage
	);

	const handleRequestSort = (property) => {
		const isAsc = orderBy === property && order === "asc";
		setOrder(isAsc ? "desc" : "asc");
		setOrderBy(property);
	};

	const handleClick = (e, id) => {
		const selectedRow = TableData.find((row) => row.objectId === id);
		const selectedIndex = selected.findIndex(
			(row) => row.objectId === selectedRow.objectId
		);

		if (selectedIndex === -1) {
			setSelected((prevSelected) => [...prevSelected, selectedRow]);
		} else {
			setSelected((prevSelected) => [
				...prevSelected.slice(0, selectedIndex),
				...prevSelected.slice(selectedIndex + 1),
			]);
		}
	};

	const handleSelectAll = (e) => {
		if (e.target.checked) {
			const newSelected = TableData.map((row) => row);
			setSelected(newSelected);
			return;
		}
		setSelected([]);
	};

	const handleChangePage = (e, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (e) => {
		setRowsPerPage(+e.target.value);
		setPage(0);
	};
	return (
		<div className="mt-10">
			<TableToolbar>
            <div className='_notification'>{TableData.length} Item(s) Found</div>
				<div className='_buttons'>
					<Select
						value={dateFilter}
						className='toolbarSelect'
						onChange={(e) => handleDateFilterChange(e)}
					>
						<MenuItem value='Today'>Today</MenuItem>
						<MenuItem value='Week'>Last 7 days</MenuItem>
						<MenuItem value='Month'>Last 30 days</MenuItem>
						<MenuItem value='6 Months'>Last 6 months</MenuItem>
						<MenuItem value='Year'>Last 12 months</MenuItem>
						<MenuItem value='All'>All Time</MenuItem>
					</Select>

					<div className='_buttons'>
						<Tooltip title='Delete' arrow>
							<TableButton
								onClick={() => {
									setConfirmModal(true);
								}}
								variant='outlined'
								color='error'
							>
								<img src={DeleteIcon} alt='' />
							</TableButton>
						</Tooltip>
					</div>
				</div>
			</TableToolbar>

			<TableWrapper>
				{confirmModal && (
					<ConfirmModal
						confirmModal={confirmModal}
						setConfirmModal={setConfirmModal}
						content={{
							title: "Delete user(s)",
							desc: "Are you sure you want to Delete these account(s)?",
							btnText: "Yes, Delete",
						}}
						handleDeleteAction={deleteMultipleAccounts}
					/>
				)}
				{loading && (
					<Backdrop
						sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
						open={loading}
						// onClick={() => setLoading(false)}
					>
						<CircularProgress color='inherit' />
					</Backdrop>
				)}
				<StyledTable sx={{ minWidth: 650 }}>
					<TableHead>
						<StyledTableRow>
							<TableCell padding='checkbox'>
								<StyledCheckbox
									color='default'
									checked={
										selected.length === TableData.length &&
										TableData.length !== 0
									}
									onChange={(e) => handleSelectAll(e)}
									inputProps={{ "aria-labelledby": "Select All" }}
								/>
							</TableCell>

							{headCells.map((headerCell) => (
								<TableCell
									key={headerCell.field}
									align='left'
									sx={{ minWidth: headerCell.width }}
								>
									<TableSortLabel
										active={orderBy === headerCell.field}
										onClick={() => handleRequestSort(headerCell.field)}
										direction={orderBy === headerCell.field ? order : "asc"}
									>
										{headerCell.title}
									</TableSortLabel>
								</TableCell>
							))}
						</StyledTableRow>
					</TableHead>

					<DataTableBody
						selected={selected}
						visibleRows={visibleRows}
						handleClick={handleClick}
						headCells={headCells}
					/>
				</StyledTable>
			</TableWrapper>

			<StyledTablePagination
				rowsPerPageOptions={[10, 20, 25, 100]}
				component='div'
				count={TableData.length}
				rowsPerPage={rowsPerPage}
				page={page}
				onPageChange={handleChangePage}
				onRowsPerPageChange={handleChangeRowsPerPage}
			/>
		</div>
	);
}

const DataTableBody = ({ selected, visibleRows, handleClick, headCells }) => {
	const isSelected = (id) =>
		selected.findIndex((row) => row.objectId === id) !== -1;

	const TableRowItem = ({ row, headerCell }) => {
		// console.log(row);

		if (headerCell.title === "ACTION") {
			return (
				<TableButton
					component={Link}
					variant='outlined'
					size='small'
					to={`./${row.objectId}`}
				>
					View
				</TableButton>
			);
		}

		if (headerCell.field === "createdAt") {
			return (
				<span className={headerCell.field}>
					{getFormattedDate(row["createdAt"])}
				</span>
			);
		}

        const percentageFields = ["interestRate", "interest"];
		if (percentageFields.includes(headerCell.field)) {
			const hasPercentageSymbol = row[headerCell.field]?.toString().includes("%");
			const value = hasPercentageSymbol ? row[headerCell.field] : row[headerCell.field] + "%";
			return <span className={headerCell.field}>{row[headerCell.field] ? value : "---"}</span>;
		}

        const AmountFields = [
			"savings",
			// "commitmentFee",
			"amount",
            "amountToRaise",
			"expectedProfit",
            "programSavings"
		];
		if (AmountFields.includes(headerCell.field)) {
			return <span className={headerCell.field}>{getNairaFormat(row[headerCell.field])}</span>;
		}

        const UserNameFields = ["apprentice"]
		if (UserNameFields.includes(headerCell.field)) {
			return <span className={headerCell.field}>{(row?.name1 || "--") + ' ' + (row?.name2 || "--")}</span>;
		}

        
		if (headerCell.field === "trnId") {
			return <span className={headerCell.field}>{"TRN-" + row.objectId}</span>;
		}

		return (
			<span className={headerCell.field}>
				{row[headerCell.field] ? row[headerCell.field] : "---"}
			</span>
		);
	};

	return (
		<TableBody>
			{visibleRows.map((row) => {
				const isItemSelected = isSelected(row.objectId);
				return (
					<StyledTableRow
						hover
						key={row.objectId}
						onClick={(e) => handleClick(e, row.objectId)}
						role='checkbox'
						selected={isItemSelected}
					>
						<TableCell padding='checkbox'>
							<StyledCheckbox
								color='default'
								checked={isItemSelected}
								inputProps={{ "aria-labelledby": row.objectId }}
							/>
						</TableCell>

						{headCells.map((headerCell) => (
							<TableCell key={headerCell.field} align='left'>
								<TableRowItem row={row} headerCell={headerCell} />
							</TableCell>
						))}
					</StyledTableRow>
				);
			})}

			{visibleRows.length === 0 && (
				<StyledTableRow>
					<TableCell
						colSpan={headCells.length + 1}
						align='center'
						className='no_data_found'
					>
						NO DATA FOUND
					</TableCell>
				</StyledTableRow>
			)}
		</TableBody>
	);
};

export default AccountTable;
